// hooks/useCreateApiToken.ts
import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useI18n } from '@monorepo/i18n';
import { useNotifications } from '@monorepo/notification';
import { getGrpcPromise, TGRPCPromiseReject } from '@monorepo/grpc';

import {
  CreateApiTokenRequest,
  ApiToken
} from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';

const useCreateApiToken = () => {
  const { t } = useI18n();
  const { errorNotification, successNotification } = useNotifications();

  const mutator = (): Promise<ApiToken.AsObject> => {
    const req = new CreateApiTokenRequest();
    return getGrpcPromise(WebAuthService.CreateApiToken)(req);
  };

  const onSuccess = useCallback(
    () => successNotification(t('api.tokens.created')),
    [successNotification, t]
  );

  const onError = useCallback(
    (err: TGRPCPromiseReject) =>
      errorNotification(t(`api.tokens.create_error.${err.status}`)),
    [errorNotification, t]
  );

  // useMutation<TData, TError, TVariables>
  return useMutation<
    ApiToken.AsObject,
    TGRPCPromiseReject,
    CreateApiTokenRequest.AsObject | void
  >({ mutationFn: mutator, retry: false, onSuccess, onError });
};

export default useCreateApiToken;
